import { saveAs } from "file-saver";

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export function saveData(data: any, filename: string, mime: string): void {
  const blob = new Blob([data], { type: mime || "application/octet-stream" });
  saveBlob(blob, filename);
}

export function saveBlob(blob: Blob, filename: string): void {
  saveAs(blob, filename);
}
